import { Injectable } from "@angular/core";
import { User } from "../../objects/users/user";
import { UserService } from "../../services/userService";
import { CookieService } from "ng2-cookies";
import { ConfigService } from "../../services/configService";
import {Cookie} from "ng2-cookies/ng2-cookies";

@Injectable()
export class StorageManager {

    private user: User;

    constructor(private userService: UserService, private cookieService: CookieService, public configService: ConfigService) {
    }

    public getCurrentUser(): Promise<User> {
        if (this.user != null)
            return new Promise((resolve, reject) => resolve(this.user));

        if (!Cookie.get(this.configService.config.UserCookieName))
            return null;

        const userId = +Cookie.get(this.configService.config.UserCookieName);

        return this.userService.getById(userId).then(x => {
            this.user = x.Data;
            return this.user;
        });
    }

    public setCurrentUser(obj: User) {
        this.user = obj;

        if (obj == null) {
            this.cookieService.delete(this.configService.config.ApiTokenCookieName);
            this.cookieService.delete(this.configService.config.UserCookieName);
        }
    }

    public logout() {
        this.setCurrentUser(null);
    }
}


// WEBPACK FOOTER //
// ./app/common/managers/storageManager.ts